import { render, staticRenderFns } from "./RecoverUser.vue?vue&type=template&id=58c444ca&scoped=true"
import script from "./RecoverUser.vue?vue&type=script&lang=js"
export * from "./RecoverUser.vue?vue&type=script&lang=js"
import style0 from "./RecoverUser.vue?vue&type=style&index=0&id=58c444ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c444ca",
  null
  
)

export default component.exports